import axios from "axios";
import { authActions } from "@store/auth";
var JSONbig = require("json-bigint");

const BASE_URL = process.env.REACT_APP_API_URL;

let store;

export const injectStore = (_store) => {
	store = _store;
};

const getCookie = (cname) => {
	const name = cname + "=";
	const ca = document.cookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
};

axios.defaults.transformResponse = [
	(data) => {
		if (typeof data === "string") {
			try {
				data = JSONbig.parse(data);
			} catch (e) {
				/* Ignore */
			} // Added this Ignore as it's the same in the Axios
		}
		return JSON.parse(JSON.stringify(data));
	},
];

const instance = axios.create({
	baseURL: BASE_URL,
});

instance.interceptors.request.use(
	(config) => {
		const token = getCookie("loginToken");
		if (token && !config.noHeader) {
			config.headers["Authorization"] = `Bearer ${token}`;
		}
		return new Promise((resolve) => setTimeout(() => resolve(config), 1));
	},
	function (error) {
		return Promise.reject(error);
	}
);

instance.interceptors.response.use(
	(response) => response,
	(error) => {
		const { status } = error.response;
		if (status === 403 || status === 401) {
			store.dispatch(authActions.logout());
		}
		return Promise.reject(error.response.data);
	}
);
export default instance;
